import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './contact.css'
import toast, { Toaster } from 'react-hot-toast';
import ModelCanavas from './ThreeD';
const Contact = () => {
  const notify1 = () => {
    toast('Mail sent');
  }
  const notify2 = () => {
    toast('Something went wrong');
  }
  const form = useRef();
  const Reset = () => {
    form.current.user_name.value = ''
    form.current.user_email.value = ''
    form.current.message.value = ''
  }
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_xi18gj6', 'template_ae7k45k', form.current, 'XSVM95fQSfNHPe6hD')
      .then((result) => {
        notify1()
      }, (error) => {
        notify2()
      });
    Reset()
  };

  return (
    <div className='contact-section' >
      <h2 className="section-title">Let's have a Chat</h2>
      <div className="contact-container">
        <div className="contact-right">
          <ModelCanavas />
        </div>
        <form ref={form} onSubmit={sendEmail} className='contact-form'>
          <label className='label'>Name:</label>
          <input type="text" name="user_name" placeholder='Enter your Name' required />
          <label className='label'>Email:</label>
          <input type="email" name="user_email" placeholder='Enter your email' required />
          <label className='label'>Message:</label>
          <textarea name="message" className='textarea' placeholder='enter the message' required />
          <div className="but-div">
            <button type="submit" className='button-28'>Send</button>
            {/* <Rocket/> */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
